import { Box, BoxProps, Text } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common';
import React from 'react';

interface BannerLayoutProps extends BoxProps {
  title: string;
  items: (string | React.ReactNode)[];
  backgroundColor?: string;
}

export const BannerLayout = ({ title, items }: BannerLayoutProps) => {
  return (
    <Box direction="horizontal" margin="0 auto" width="100%" align="center">
      <Box marginRight="SP2">
        <Text size="medium">{title}</Text>
      </Box>
      <Box gap="SP2" direction="horizontal">
        {items.map((item, idx) => (
          <Box key={idx}>
            <Check />
            <Text>{item}</Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
